// export DsfUniteHomeAnnouncemenMail from "./announcemenMail.vue";
export const DsfUniteHomeAnnouncemenMail = dsf.defineAsyncComponent(
  "DsfUniteHomeAnnouncemenMail",
  () => {
    return dsf.requestAsyncComponents($components.platform.DsfVirtualList).then(() => {
      return import(/*webpackChunkName:"platform_pc_homepage"*/ "./announcemenMail.vue");
    });
  }
);
// export DsfHomeNoticeAnnouncementList from "./noticeAnnouncement.vue";
export const DsfHomeNoticeAnnouncementList = dsf.defineAsyncComponent(
  "DsfHomeNoticeAnnouncementList",
  () => {
    return dsf.requestAsyncComponents($components.platform.DsfVirtualList).then(() => {
      return import(/*webpackChunkName:"platform_pc_homepage"*/ "./noticeAnnouncement.vue");
    });
  }
);
